var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lottery-info',{staticClass:"d-none d-sm-block"}),_c('v-row',{staticClass:"mx-0",attrs:{"no-gutters":""}},[_c('lottery-betting',{staticClass:"d-none d-sm-block"}),_c('list-lottery-result')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }